import React from "react";

import ProjectCodeName from "./components/ProjectCodeName";
import ProjectFinalWork from "./components/ProjectFinalWork";
import ProjectBanner from "./components/ProjectBanner";
import ProjectSchedule from "./components/ProjectSchedule";
import ProjectShotTags from "./components/ProjectShotTags";
import ProjectOverview from "./components/ProjectOverview";
import ProjectTotalShots from "./components/ProjectTotalShots";
import ProjectEndClient from "./components/ProjectEndClient";
import ProjectAcrResults from "./components/ProjectAcrResults";
import ProjectTaskBoardAccess from "./components/ProjectTaskBoardAccess";
import ProjectGitHubRepositories from "./components/ProjectGitHubRepositories";

const rightColumnComponents = {
  projectCodeName: <ProjectCodeName />,
  projectFinalWork: <ProjectFinalWork />,
  projectBanner: <ProjectBanner />,
  projectSchedule: <ProjectSchedule />,
  projectShotTags: <ProjectShotTags />,
  projectOverview: <ProjectOverview />,
  projectTotalShots: <ProjectTotalShots />,
  projectEndClient: <ProjectEndClient />,
  projectAcr: <ProjectAcrResults />,
  projectTaskBoard: <ProjectTaskBoardAccess />,
  projectGitHub: <ProjectGitHubRepositories />,
};

export default rightColumnComponents;
